function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
export var collapseColumns = function collapseColumns(columns) {
  var columnSections = [];
  columns.forEach(function (column) {
    columnSections.push.apply(columnSections, _toConsumableArray(column.column_sections));
  });
  return columnSections;
};
export var combineColumnSections = function combineColumnSections(columnSections) {
  var combinedColumnSections = [];
  columnSections.forEach(function (columnSection, index) {
    if (columnSection.title_type === 'invisible_link' && index > 0) {
      var previousColumnSection = combinedColumnSections[combinedColumnSections.length - 1];
      previousColumnSection.links = previousColumnSection.links.concat(columnSection.links);
    } else {
      combinedColumnSections.push(_objectSpread({}, columnSection));
    }
  });
  return combinedColumnSections;
};
var transformLevel3Item = function transformLevel3Item(_ref) {
  var title = _ref.title,
    url = _ref.url;
  return {
    title,
    url,
    items: [],
    level: 3
  };
};
var transformLevel1Item = function transformLevel1Item(_ref2) {
  var category = _ref2.category;
  var contentSections = collapseColumns(category.columns);
  var combinedColumnSections = combineColumnSections(contentSections);
  return {
    title: category.title,
    url: category.columns.length ? '' : category.url,
    items: combinedColumnSections.map(function (columnSection) {
      return {
        title: columnSection.title,
        url: columnSection.links.length ? '' : columnSection.url,
        items: columnSection.links.map(transformLevel3Item),
        level: 2
      };
    }),
    level: 1
  };
};
export var legacyTransformToDrilldownProp = function legacyTransformToDrilldownProp(_ref3) {
  var navigation_categories = _ref3.navigation_categories;
  return {
    title: 'Shop by category',
    items: navigation_categories.map(function (category) {
      return transformLevel1Item(category);
    }),
    level: 0
  };
};